// extracted by mini-css-extract-plugin
export var active = "_bg-7";
export var container = "_bg-0";
export var evenWidth = "_bg-4";
export var large = "_bg-5";
export var outlet = "_bg-8";
export var slide = "_bg-2";
export var small = "_bg-6";
export var tab = "_bg-3";
export var tabs = "_bg-1";